import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { useState, useEffect } from 'react';
import ScrollReveal from '../components/ScrollReveal';
import { getOptimizedImageProps, preloadImages } from '../utils/imageOptimizer';
const Gallery = () => {
    const [selectedImage, setSelectedImage] = useState(null);
    // Preload first 6 images for better performance
    useEffect(() => {
        const criticalImages = birthPhotos.slice(0, 6).map(photo => photo.src);
        preloadImages(criticalImages);
    }, []);
    const birthPhotos = [
        {
            id: 1,
            src: '/assets/birthPhotos/optimized/AB.jpg',
            alt: 'Birth Photo AB'
        },
        {
            id: 2,
            src: '/assets/birthPhotos/optimized/a.jpg',
            alt: 'Birth Photo a'
        },
        {
            id: 3,
            src: '/assets/birthPhotos/optimized/a2.jpg',
            alt: 'Birth Photo a2'
        },
        {
            id: 4,
            src: '/assets/birthPhotos/optimized/c.jpg',
            alt: 'Birth Photo c'
        },
        {
            id: 5,
            src: '/assets/birthPhotos/optimized/cB.jpg',
            alt: 'Birth Photo cB'
        },
        {
            id: 6,
            src: '/assets/birthPhotos/optimized/cB2.jpg',
            alt: 'Birth Photo cB2'
        },
        {
            id: 7,
            src: '/assets/birthPhotos/optimized/d.jpg',
            alt: 'Birth Photo d'
        },
        {
            id: 8,
            src: '/assets/birthPhotos/optimized/d2.jpg',
            alt: 'Birth Photo d2'
        },
        {
            id: 9,
            src: '/assets/birthPhotos/optimized/d3.jpg',
            alt: 'Birth Photo d3'
        },
        {
            id: 10,
            src: '/assets/birthPhotos/optimized/k.jpg',
            alt: 'Birth Photo k'
        },
        {
            id: 11,
            src: '/assets/birthPhotos/optimized/k2.jpg',
            alt: 'Birth Photo k2'
        },
        {
            id: 12,
            src: '/assets/birthPhotos/optimized/m.jpg',
            alt: 'Birth Photo m'
        },
        {
            id: 13,
            src: '/assets/birthPhotos/optimized/p2.jpg',
            alt: 'Birth Photo p2'
        },
        {
            id: 14,
            src: '/assets/birthPhotos/optimized/p3.jpg',
            alt: 'Birth Photo p3'
        },
        {
            id: 15,
            src: '/assets/birthPhotos/optimized/p4.jpg',
            alt: 'Birth Photo p4'
        },
        {
            id: 16,
            src: '/assets/birthPhotos/optimized/p5.jpg',
            alt: 'Birth Photo p5'
        },
        {
            id: 17,
            src: '/assets/birthPhotos/optimized/r.jpg',
            alt: 'Birth Photo r'
        },
        {
            id: 18,
            src: '/assets/birthPhotos/optimized/s.jpg',
            alt: 'Birth Photo s'
        },
        {
            id: 19,
            src: '/assets/birthPhotos/optimized/s2.jpg',
            alt: 'Birth Photo s2'
        },
        {
            id: 20,
            src: '/assets/birthPhotos/optimized/t.jpg',
            alt: 'Birth Photo t'
        },
        {
            id: 21,
            src: '/assets/birthPhotos/optimized/t2.jpg',
            alt: 'Birth Photo t2'
        },
        {
            id: 22,
            src: '/assets/birthPhotos/optimized/zC.jpg',
            alt: 'Birth Photo zC'
        },
        {
            id: 23,
            src: '/assets/birthPhotos/optimized/zC2.jpg',
            alt: 'Birth Photo zC2'
        },
        {
            id: 24,
            src: '/assets/birthPhotos/optimized/zC3.jpg',
            alt: 'Birth Photo zC3'
        }
    ];
    return (_jsxs("div", { className: "min-h-screen", children: [_jsx("div", { className: "hidden", children: birthPhotos.slice(0, 6).map((photo) => (_jsx("link", { rel: "preload", as: "image", href: photo.src }, photo.id))) }), _jsx("section", { className: "bg-gradient-to-br from-amber-50 to-orange-50 py-20 px-4", children: _jsx("div", { className: "max-w-6xl mx-auto text-center", children: _jsxs(ScrollReveal, { className: "reveal", children: [_jsx("h1", { className: "text-5xl md:text-7xl font-bold text-gray-800 mb-8 font-heading", children: "Birth Gallery" }), _jsx("p", { className: "text-xl text-gray-600 max-w-3xl mx-auto font-body", children: "the sacred story of birth, photographed with love" })] }) }) }), _jsx("section", { className: "py-20 px-4 bg-white", children: _jsxs("div", { className: "max-w-7xl mx-auto", children: [_jsx("div", { className: "grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-8", children: birthPhotos.map((photo, index) => (_jsx(ScrollReveal, { className: "reveal-stagger", threshold: 0.1, children: _jsx("div", { className: "group cursor-pointer transform hover:scale-105 transition-all duration-300", onClick: () => setSelectedImage(photo.src), children: _jsx("div", { className: "relative overflow-hidden rounded-2xl shadow-lg hover:shadow-xl", children: _jsx("img", Object.assign({}, getOptimizedImageProps(photo.src, photo.alt, {
                                            className: "w-full h-auto object-contain group-hover:scale-105 transition-transform duration-300"
                                        }))) }) }) }, photo.id))) }), _jsx(ScrollReveal, { className: "reveal text-center mt-16", children: _jsx("div", { className: "bg-amber-50 rounded-2xl p-8 max-w-2xl mx-auto", children: _jsxs("p", { className: "text-gray-700 font-body", children: [_jsx("strong", { children: "Note:" }), " These photos are shared with permission from the families."] }) }) })] }) }), selectedImage && (_jsx("div", { className: "fixed inset-0 z-50 flex items-center justify-center bg-black bg-opacity-95", onClick: () => setSelectedImage(null), children: _jsxs("div", { className: "relative w-full h-full flex items-center justify-center p-4", children: [_jsx("button", { onClick: (e) => {
                                e.stopPropagation();
                                setSelectedImage(null);
                            }, className: "absolute top-4 right-4 text-white hover:text-gray-300 transition-colors z-10 bg-black bg-opacity-50 rounded-full p-2", children: _jsx("svg", { className: "w-8 h-8", fill: "none", stroke: "currentColor", viewBox: "0 0 24 24", children: _jsx("path", { strokeLinecap: "round", strokeLinejoin: "round", strokeWidth: 2, d: "M6 18L18 6M6 6l12 12" }) }) }), _jsx("div", { className: "max-w-[95vw] max-h-[95vh] flex items-center justify-center", onClick: (e) => e.stopPropagation(), children: _jsx("img", { src: selectedImage, alt: "Full size birth photo", className: "max-w-full max-h-full object-contain rounded-lg shadow-2xl", style: { maxWidth: '95vw', maxHeight: '95vh' } }) })] }) }))] }));
};
export default Gallery;
